export const VALID_LINK_PROTOCOLS = [
  "http",
  "https",
  "ftp",
  "ftps",
  "mailto",
  "tel",
  "callto",
  "sms",
  "cid",
  "xmpp",
];
export const DEFAULT_LINK_PROTOCOL = "https";
